import { useEffect, useRef, useState } from "react";

interface IStopwatch {
    millisecondsElapsed: number,
    minutesElapsed: number,
    secondsElapsed: number,
    start: () => void,
    stop: () => number,
}

function useStopwatch() : IStopwatch {
    const [elapsed, setElapsed] = useState(0);
    const stopwatchIntervalId = useRef<number | undefined>(undefined);

    const startTime = useRef<number | undefined>(undefined);

    useEffect(() => {
        return () => {
            if (stopwatchIntervalId.current) {
                clearInterval(stopwatchIntervalId.current);
            }
        };
    }, []);

    function start()
    {
        startTime.current = performance.now();
        setElapsed(0);
        if (stopwatchIntervalId.current) clearInterval(stopwatchIntervalId.current);

        stopwatchIntervalId.current = window.setInterval(() => {
            if (startTime.current) setElapsed(performance.now() - startTime.current)
        }, 500);
    }

    function stop()
    {
        if (stopwatchIntervalId.current) clearInterval(stopwatchIntervalId.current);
        stopwatchIntervalId.current = undefined;
        return startTime.current ? Math.floor(performance.now() - startTime.current) : 0;
    }

    const totalSeconds = Math.floor(elapsed / 1000);
    const minutesElapsed = Math.trunc(totalSeconds / 60);
    const secondsElapsed = totalSeconds % 60;

    return {
        millisecondsElapsed: elapsed,
        minutesElapsed,
        secondsElapsed,
        stop,
        start
    }
}

export default useStopwatch;
